import axios from 'axios';
import { useEffect, useState } from 'react'
import { CircularProgress, Pagination } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import {ProjectConfig} from 'Global';
import TopBar from 'elements/TopBar/TopBar';
import FiltersApplied from 'elements/Filters/FiltersApplied';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import Cookies from 'universal-cookie';
import { stringify } from 'querystring';
import { getAcuerdosLabel } from 'hooks/useLabels';

const cookies = new Cookies();

export default function AcuerdosCategories (props:any) {

  const lang_id = localStorage.getItem('lang_id') || '1';

  //userChecks {} any
  const [userChecks, setUserChecks] = useState<any>({
    acuerdos:[],
    constituciones:[]
  });
  const modulo  = 'Acuerdos';
  /*================================================
  GET USER_CHECKS // send user_id
  =================================================*/
  useEffect(() => {
    props.setLoading(true);
    axios.get(ProjectConfig.api_url,
    {
      params: {
        request: 'user_checks',
         //cookie user_id 
        user_id: cookies.get('user_id')

      }
    })
      .then((response) => {
        setUserChecks(response.data);
        props.setLoading(false);
      })
      .catch((err) => {
        console.log(err.data);
      })
  }, [])
  /*================================================*/


  
  /*================================================
  FILTERS
  =================================================*/
  const filters = [
    {type: "text", label: "Título", name: "title", value: ""},
  ]
  const [applyFilters, setApplyFilters] = useState(false);
  const [filtersValues, setFiltersValues] = useState<any>({});

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
  }
  /*================================================= 
  ==================================================*/


  const [loading, setLoading] = useState(false); 
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);
  const currentPage=parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);
  const [refreshList, setRefreshList] = useState(0);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
    props.setLoading(true);
      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'acuerdos_category_list',
          filters: filtersValues,
          page: page,
          user_id: cookies.get('user_id'),
          modulo,
          lang_id: lang_id
        }
      })
        .then((response) => {
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
          props.setLoading(false);
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        localStorage.setItem('page', page.toString())
    
  }, [page, refreshList, filtersValues])
  /*=========================================================*/




  /*=========================================================
  HANDLE BOOKMARK CHECK      
  =========================================================*/

  const handleBookmark = (category_id: any) => {
    //IF ID IS IN ARRAY, REMOVE IT , IF NOT ADD IT    
    if(userChecks.acuerdos.includes(category_id)){
      setUserChecks({
        ...userChecks,
        acuerdos: userChecks.acuerdos.filter((item: any) => item !== category_id)
      })
    }
    else{
      setUserChecks({
        ...userChecks,
        acuerdos: [...userChecks.acuerdos, category_id]
      })
    }
    setTriggerUpdate(true)
  }

  /*=========================================================*/


  /*=========================================================
  UPLOAD USER_CHECKS      
  =========================================================*/

  const [triggerUpdate, setTriggerUpdate] = useState(false);
  
  useEffect(() => {
    if(triggerUpdate){
      props.setLoading(true);
      axios.post(ProjectConfig.api_url, null,
        {
          params: {
            request: 'update_user_checks',
            user_id: cookies.get('user_id'),
            userChecks: userChecks
          }
        })
          .then((response) => {
            setTriggerUpdate(false)
            props.setLoading(false);
          })
          .catch((err) => {
            console.log(err.data);
          })
    }
  }, [triggerUpdate])
  /*=========================================================*/





  return (
    <div id='Acuerdos' className='module_container'>
      
      <div className="module_topBar">
        <TopBar title={getAcuerdosLabel('acuerdos_titulo')} filters={filters} setFilters={setFilters}/>
      </div>
      

      <FiltersApplied filtersValues={filtersValues} setFiltersValues={setFiltersValues}/>
     

      
      <div className='module_content'>
        <div id="task_list_container" className="flex_column">
          
            

              {list.map((list_item,key) => {

                return (
                  
                  <div className='CardChecker' key={key}>    

                      <Link to={`/acuerdos-capitulares/${list_item.acuerdos_category_id}`} className='CardChecker_title' onClick={()=> {props.setLoading(true)}}>
                        <span className='CardListTitle'>{list_item.title}</span>
                      </Link>

                      <div className="bookmarkContainer">
                        {/* IF userchecks has acuerdos_category_id */}
                        {userChecks.acuerdos.includes(list_item.acuerdos_category_id) ?
                          <BookmarkIcon className="bookmark" onClick={()=>handleBookmark(list_item.acuerdos_category_id)} /> : 
                          <BookmarkBorderIcon className="bookmark" onClick={()=>handleBookmark(list_item.acuerdos_category_id)} />
                        }
                      </div>
                  </div>
              )})}

          
          <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          />
 
        </div>
      </div>
    </div>
  );
};



